/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import swan from "../services/swanservice";
import { SCAN_STATUS, SCAN_TYPE, STORAGE_KEY } from "../services/constant";
import { checkIsToShowCaraousal, fetchRecommendation, getLocalStorage } from "../utils/Utils";
import Loading from "./loading/Loading";
import ResultOverview from "./ResultOverview";
import ResultDetails from "./ResultDetails";
import ParamsContext from "../context/ParamsContext";
import { useMeasurementSocket } from "../hooks/useMeasurementCheck";
import { useWrapperContext, WrapperContext } from "../context/WrapperContext";
import { IMAGES_DATA } from "../services/ImagesData";
import tryOnService from "../services/tryonService";

const ShowResultComponent = ({ isTryonAvailable, scanRes, scanType, shopDomain }) => {
	const { email, scanId, productHandle, faceScanId } = useWrapperContext();
	const [tryonData, setTryonData] = useState();
	const [scanData, setScanData] = useState();
	const [loading, setLoading] = useState(true);
	const [showResult, setShowResult] = useState(false);
	const [productDetails, setProductDetails] = useState();
	const [scanStatus, setScanStatus] = useState(scanRes);
	const handleWebsocket = useMeasurementSocket();
	const { resetButton } = useContext(WrapperContext);
	console.log(faceScanId, "faceScanId");
	console.log(isTryonAvailable, "isTryonvaialable");
    const [tryonLoading,setTryonLoading] = useState(false)
	const handleTryonAutoGenerate = async () => {
		setTryonLoading(true)
		try {
			const res = await tryOnService.tryonSubmit({
				token: getLocalStorage(STORAGE_KEY.JWTToken) || "",
				shopDomain:"swanopentryonstaging.myshopify.com",
				products: [{ productUrl: "https://www.zara.com/in/en/contrast-collar-polo-sweatshirt-p00526320.html?v1=411120087&v2=2432049" || window.location.href.split("?")?.[0], productHandle:"305992cfe5da39c82b46f5b1306a092c" }],
			});
			console.log(res?.data);
			tryOnService.handleTryOnWebSocket({
				tryonId: res?.data?.tryonId,
				onSuccess: (e) => {
					console.log(e, "success");
					const url = e?.images?.[0]?.downloadUrl?.url;
					if (url) {
						setTryonData(url);
					}
					setTryonLoading(false)
				},
				onError: (e) => {
					console.log(e, "error");
					// setTryonLoading(false)
				}
			});
		} catch (error) {
			setTryonLoading(false)
			console.log(error, "while tryon submit");
		}
	}
	const IsToShowCaraousal = useMemo(() => {
		return checkIsToShowCaraousal({ shopDomain, email });
	}, [shopDomain, email]);

	const onSuccess = useCallback((data) => {
		console.log(data, "success");
		setScanStatus(SCAN_STATUS.FULLFILLED);
		handleGetResult(SCAN_STATUS.FULLFILLED);
	}, []);

	const onError = useCallback((data) => {
		console.log(data, "error");
		setScanStatus(SCAN_STATUS.FAILED);
		handleGetResult(SCAN_STATUS.FAILED);
	}, []);
	const handleGetTryonResult = useCallback(
		async (status) => {
			if (IsToShowCaraousal) {
				setTryonData(IMAGES_DATA?.[productHandle]?.url?.[0]);
				return;
			}
			console.log(isTryonAvailable,"isTryonAvailable");
			
			if (!isTryonAvailable) {
				if (status === SCAN_STATUS.FAILED || scanStatus === SCAN_STATUS.FAILED) {
					resetButton();
				} else if (faceScanId) {
					handleTryonAutoGenerate();
				}
				return;
			}
			try {
				const res = await swan.tryOn.getTryOnResult({
					tryonId: isTryonAvailable,
				});
				const url = Object.values(res?.data?.downloadUrls)?.[0]?.url;
				if (url) {
					setTryonData(url);
				}
			} catch (error) {
				console.log(error);
				if (status === SCAN_STATUS.FAILED || scanStatus === SCAN_STATUS.FAILED) {
					resetButton();
				}
			}
		},
		[isTryonAvailable, scanStatus, IsToShowCaraousal, productHandle, faceScanId],
	);

	const handleGetMeasurementResult = useCallback(
		async (status) => {
			if (scanStatus === SCAN_STATUS.FAILED || status === SCAN_STATUS.FAILED || !scanId) {
				return;
			}
			try {
				const res = await fetchRecommendation({
					shopDomain,
					productHandle,
					scanID: scanId,
				});
				setScanData(res);
			} catch (error) {
				console.log(error);
			}
		},
		[productHandle, scanId, shopDomain, scanStatus],
	);

	const handleGetResult = useCallback(
		async (status) => {
			setLoading(true);
			switch (scanType) {
				case SCAN_TYPE.CLOTHING_SCAN_WITH_TRY_ON: {
					await handleGetMeasurementResult(status);
					await handleGetTryonResult(status);
					setLoading(false);
					return;
				}
				case SCAN_TYPE.CLOTHING_TRY_ON_ONLY: {
					await handleGetTryonResult();
					setLoading(false);
					return;
				}
				case SCAN_TYPE.CLOTHIN_SCAN_ONLY: {
					if (status === SCAN_STATUS.FAILED || scanStatus === SCAN_STATUS.FAILED) {
						resetButton();
					} else {
						await handleGetMeasurementResult(status);
					}
					setLoading(false);
					return;
				}
				default: {
					console.log("Unknown scan type:", scanType);
					return;
				}
			}
		},
		[handleGetMeasurementResult, handleGetTryonResult, scanType, scanStatus],
	);

	const handleShowResult = useCallback(() => {
		setShowResult(!showResult);
	}, [showResult]);

	useEffect(() => {
		if (scanStatus === SCAN_STATUS.PENDING) {
			setLoading(false);
			handleWebsocket({ scanId: scanId, onSuccess, onError });
		} else {
			handleGetResult();
		}
	}, [scanStatus]);

	return loading ? (
		<Loading height="58px" />
	) : (
		<>
			<div onClick={scanStatus !== SCAN_STATUS.PENDING ? handleShowResult : null}>
				<ResultOverview scanStatus={scanStatus} buttonText={scanStatus === SCAN_STATUS.PENDING ? "Measurement in Progress" : ""} imgUrl={tryonData} />
			</div>
			{showResult && (
				<ParamsContext.Provider
					value={{
						tryonData,
						scanData,
						setProductDetails,
						productDetails,
						isTryonAvailable,
						scanRes,
						IsToShowCaraousal,
						tryonLoading
					}}
				>
					<ResultDetails />
				</ParamsContext.Provider>
			)}
		</>
	);
};

export default ShowResultComponent;
